// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titlebar {
  height: 32px;
  background-color: var(--bg-tertiary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-app-region: drag;
  user-select: none;
  border-bottom: 1px solid var(--glass-border);
  z-index: 9999;
}

.titlebar-drag {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 12px;
}

.titlebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-logo-img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  filter: drop-shadow(0 0 4px rgba(153, 27, 27, 0.4));
}

.titlebar-brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand-name {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: 1px;
}

.brand-status {
  font-size: 9px;
  font-weight: 700;
  background-color: var(--brand-primary);
  color: white;
  padding: 1px 6px;
  border-radius: 4px;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.titlebar-controls {
  display: flex;
  -webkit-app-region: no-drag;
}

.control-btn {
  width: 44px;
  height: 32px;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.control-btn:hover {
  background-color: var(--bg-modifier-hover);
  color: var(--text-primary);
}

.control-btn.close:hover {
  background-color: #e81123;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/TitleBar/TitleBar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".titlebar {\n  height: 32px;\n  background-color: var(--bg-tertiary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  -webkit-app-region: drag;\n  user-select: none;\n  border-bottom: 1px solid var(--glass-border);\n  z-index: 9999;\n}\n\n.titlebar-drag {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-left: 12px;\n}\n\n.titlebar-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.m-logo-img {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  filter: drop-shadow(0 0 4px rgba(153, 27, 27, 0.4));\n}\n\n.titlebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.brand-name {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: 1px;\n}\n\n.brand-status {\n  font-size: 9px;\n  font-weight: 700;\n  background-color: var(--brand-primary);\n  color: white;\n  padding: 1px 6px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n  opacity: 0.8;\n}\n\n.titlebar-controls {\n  display: flex;\n  -webkit-app-region: no-drag;\n}\n\n.control-btn {\n  width: 44px;\n  height: 32px;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.control-btn:hover {\n  background-color: var(--bg-modifier-hover);\n  color: var(--text-primary);\n}\n\n.control-btn.close:hover {\n  background-color: #e81123;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
